export default __webpack_public_path__ + "static/media/private_capital-2-lt.0758f176.png";